import React, { useEffect } from 'react';
import { connect } from 'react-redux';

// import Grid from '@mui/material/Grid';
// import RadiologyIcon from '@mui/icons-material/ContrastOutlined';

import { RadiologyTableContainer } from '../../components/radiology';
// import StatsBox from '../../components/shared/StatsBox';

import { fetchRadiology } from '../../actions/adminActions';

import './admin.scss';

const RadiologyPage = ({ fetchRadiology, radiology, countries, companies, users }) => {
  useEffect(() => {
    fetchRadiology();
  }, [fetchRadiology])

  return (
    <div className="admin-page">
      {/*<Grid container spacing={3} sx={{ mb: 3 }}>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Radiology' number={radiology?.length} icon={<RadiologyIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Radiology' number={radiology?.length} icon={<RadiologyIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Radiology' number={radiology?.length} icon={<RadiologyIcon />} />*/}
      {/*  </Grid>*/}
      {/*</Grid>*/}
      <RadiologyTableContainer
        radiology={radiology}
        countries={countries}
        companies={companies}
        users={users}
        withButton
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  radiology: state.radiology.list,
  countries: state.countries.list,
  companies: state.companies.list,
  users: state.users.list,
});

const mapDispatchToProps = (dispatch) => ({
  fetchRadiology: () => dispatch(fetchRadiology()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RadiologyPage);
